// @flow
import { Cancel, Check } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CONFIRMATION } from "../../locales/components/namespaces";

type Props = {
	open: boolean,
	handleDialog: Function
};

const Confirmation = (props: Props) => {
	const {
		open,
		handleDialog,
		title,
		onYes = () => {
		},
		onNo = () => {
		},
		yesBtnText,
		noBtnText,
		hasBtnIcons = true,
		yesAction = true,
		noAction = true,
		maxWidth = 'xs',
		loading = false,
		sx = {},
		otherDialogProps = {}
	} = props
	const { t } = useTranslation(CONFIRMATION)
	const handleClose = (evt, details) => {
		if (details === 'backdropClick' || details === 'escapeKeyDown') return
		handleDialog(false)
	}
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth={maxWidth}
			sx={sx}
			{...otherDialogProps}
		>
			<DialogTitle>
				<Typography
					sx={{
						mt: 1,
						fontSize: '18px',
						fontWeight: 400,
						lineHeight: '20px',
						letterSpacing: '0em',
						textAlign: 'left'
					}}
				>
					{title}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<DialogContentText component={'div'}>
					{props.children}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{display:'flex', flexWrap:'wrap'}}>
				{yesAction && (
					<LoadingButton
						className='bnt-popup-ok'
						variant={"contained"}
						color={'success'}
						onClick={onYes}
						startIcon={hasBtnIcons ? <Check/> : null}
						loading={loading}
					>
						{yesBtnText ? yesBtnText : t('YES')}
					</LoadingButton>
				)}
				{noAction && (
					<LoadingButton
						className='bnt-popup-cancel'
						onClick={onNo}
						startIcon={hasBtnIcons ? <Cancel/> : null}
						sx={{
							marginLeft: 'auto'
						}}
						loading={loading}
					>
						{noBtnText ? noBtnText : t('NO')}
					</LoadingButton>
				)}
			</DialogActions>
		</Dialog>
	)
};

export default Confirmation